module.exports = __webpack_public_path__ + "img/eurocom.ac40080d.png";